import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


/////////////////////////////////////////////////////////
// 3rd Party Libraries
////////////////////////////////////////////////////////
import { MarkdownModule } from 'ngx-markdown';


/////////////////////////////////////////////////////////
// Common Libraries
////////////////////////////////////////////////////////
import { CoreUIModule } from '@coreui/coreui.module'

import { DynamicCloudsBackgroundModule } from '@libraries/dynamic-clouds/dynamicclouds.module'

/////////////////////////////////////////////////////////
// Templates
////////////////////////////////////////////////////////

/* Landing */
import { LandingPage01Template } from './landing-page/landing.page01'

/* Blog */
import { BlogPageM3Template } from './blog/blog.m3'

/* Technical Document */
import { TechnicalDocumentPageTemplate } from './tech-documentation/technical.document.page'

/* Web appbars */
import { WebAppbarWSearchComponent } from './appbars/webapp-w-search/web.appbar.w.search.component'

/* SAAS */
import { SaaSPageContentContainer } from './saas/saas.content.container'
import { SassToolbarComponent } from './saas/collection-management-toolbar/saas.toolbar.component'

/* List Detail */
import { ListDetailPage } from './list-detail/list.detail.page'



import { AppUIPageHeading } from './applicationui/page-headers/appui.page.heading';



@NgModule({
  declarations: [
    LandingPage01Template,
    BlogPageM3Template,
    TechnicalDocumentPageTemplate,

    // Appbars
    WebAppbarWSearchComponent,

    SaaSPageContentContainer,
    SassToolbarComponent,

    // List Detail
    ListDetailPage,


    // App UI
    AppUIPageHeading
   
  ],

  imports: [
    CommonModule,
    MarkdownModule.forRoot(),
    CoreUIModule,
    DynamicCloudsBackgroundModule
  ],

  providers: [
 
  ],

  exports: [
    LandingPage01Template,
    BlogPageM3Template,
    TechnicalDocumentPageTemplate,

    // Appbars
    WebAppbarWSearchComponent,

    SaaSPageContentContainer,
    SassToolbarComponent,

    // List Detail
    ListDetailPage,


    // App UI
    AppUIPageHeading


  ]
})
export class LayoutTemplatesModule { }
